import * as React from 'react';
import { SVGProps } from 'react';

const IconAxisZSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 13v1l3-1.5-3-1.5v1H9a.5.5 0 0 0-1 0H6a.5.5 0 0 0-1 0H2.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 1 0h2a.5.5 0 0 0 1 0h2Z"
      fill="var(--color-typo-system)"
    />
    <path
      d="M4 5h1L3.5 2 2 5h1v2a.5.5 0 0 0 0 1v2a.5.5 0 0 0 0 1v2.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0 0-1V8a.5.5 0 0 0 0-1V5ZM6.006 10v-.878L9.261 4.22H6V3h4.994v.878L7.736 8.78H11V10H6.006Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconAxisZSizeS;
